import { splitAssistantResponse } from '../../utils/assistantResponseParser';

export interface SearchMatch {
	messageIndex: number;
	matchIndex: number;
	startOffset: number;
	endOffset: number;
}

export function parseAssistant(raw: string, model?: string): { final: string; analysis?: string } {
	const { final, analysis } = splitAssistantResponse(raw || '', model);
	return { final, analysis: analysis || undefined };
}
